module.exports = __webpack_public_path__ + "img/yeguang.b72efc7f.png";